/**
 * Aktiven Abschnitt in der Anker-Navigation markieren (aria-current="true" am Link).
 * Aktiv ist der Abschnitt, der die Linie auf 35 % der Fensterhöhe schneidet. Oben im Hero ist nichts aktiv.
 */
import { qs, qsa } from '../utils/dom.js';

export function init() {
	const nav = qs('[data-pa-nav]');
	if (!nav || !('IntersectionObserver' in window)) return;

	const links = qsa('a.pa-nav__link[href*="#"]', nav)
		.map((link) => {
			const id = decodeURIComponent(link.hash.slice(1));
			const target = id && document.getElementById(id);
			return target ? { link, target } : null;
		})
		.filter(Boolean);
	if (!links.length) return;

	const setActive = (target) => {
		links.forEach(({ link, target: t }) => {
			if (t === target) link.setAttribute('aria-current', 'true');
			else link.removeAttribute('aria-current');
		});
	};

	const io = new IntersectionObserver((entries) => {
		entries.forEach((entry) => { if (entry.isIntersecting) setActive(entry.target); });
	}, { rootMargin: '-35% 0px -64% 0px' });

	links.forEach(({ target }) => io.observe(target));

	// Ganz oben (Hero) nichts markieren
	window.addEventListener('scroll', () => {
		if (window.scrollY < window.innerHeight * 0.5) setActive(null);
	}, { passive: true });
}
